import React, { useState } from "react"
import { apiService } from "../../api/axiosInstance"
import _ from "lodash"

import { Formik, Form } from "formik"
import { useNavigate } from "react-router-dom"

import schemaBuilder from "../../components/schemaBuilder"

// constants
import { ENTITY, ADD } from "../../config/constants"

// hooks
import useGetFormDef from "../../hooks/useGetFormDef"

// comps
import FieldBuilder from "../../components/FieldBuilder"
import { LoaderSmall, LoaderSkeleton } from "../../components/Loaders"

// PR
import { Button } from "primereact/button"

export default function FormWrapper({ type, docValues }) {
  const navigate = useNavigate()

  const [msg, setMsg] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const handleFormId = () => {
    switch (type) {
      case "add":
        return ENTITY.USER
      case "add-hfma":
        return ENTITY.USER_HFMA
      case "edit":
        return ENTITY.USER
      case "edit-hfma":
        return ENTITY.USER_HFMA
      default:
        return null
    }
  }

  const params = {
    formId: handleFormId(),
  }

  const [error, loading, def] = useGetFormDef(params)

  if (error) return <div>Err...</div>
  if (loading) return <LoaderSkeleton count={4} />

  const [initialValues, validationSchema] = schemaBuilder(def.fields)

  const handleSubmit = async (values) => {
    setSubmitting(true)
    try {
      let response
      if (type === "edit" || type === "edit-hfma") {
        response = await apiService.patch(`/users/${docValues.id}`, values)
      } else {
        response = await apiService.post(`/${ADD.USER}`, values)
      }
      setSubmitting(false)
      if (response.data.status === "success") {
        return navigate("/user/list")
      }
      setMsg(response.data.msg)
    } catch (error) {
      const { msg } = error.response.data.data
      setMsg(msg)
      setSubmitting(false)
    }
  }

  const handleInitialValues = () => {
    switch (type) {
      case "add":
        return initialValues
      case "add-hfma":
        initialValues.ref_organization = "hfma"
        initialValues.user_role = 15
        return initialValues
      case "edit":
      case "edit-hfma":
        return {
          ...initialValues,
          ...docValues,
        }
      default:
        return null
    }
  }

  if (msg) {
    return (
      <div>
        <h3>Error creating User</h3>
        <p>{msg}</p>
        <Button
          icon="pi pi-backward"
          label="Back"
          size="small"
          onClick={() => setMsg(null)}
        />
      </div>
    )
  }

  return (
    <Formik
      initialValues={handleInitialValues()}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Form style={{ margin: "15px 30px" }}>
          <FieldBuilder fields={def.fields} editMode={type === "edit"} />
          <Button type="submit" disabled={submitting}>
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  )
}
